import * as api from "app/api/sessionApi";
import { SessionHelper } from "app/helpers/sessionHelper";
import { ScreenType } from "app/utils/const";

// helper for navbar component
export class NavbarHelper {
  // an event is live if `allowLiveBetting` and `inRunning` are true
  static checkPaths: (location: any) => boolean = (
    location: Record<string, any>
  ) => {
    return (
      !SessionHelper.isAuthenticated() &&
      !window.location.pathname.includes("reset") &&
      location.pathname !== "/login/"
    );
  };

  static logout: (props: any) => void = (props: Record<string, any>) => {
    api.logout();
    props.setNotificationPlatform("HOMEPAGE");
    props.loadNotifications();
    // check dark mode status from local storage
    let darkModeStatus = SessionHelper.getDarkModeStatus();
    SessionHelper.clearLocalStorage();
    if (darkModeStatus === "true") {
      // clear all local storage but retain dark mode status
      SessionHelper.saveDarkModeStatus(true);
    }
  };

  static redirectTo: (e: any, props: any) => void = (
    e: any,
    props: Record<string, any>
  ) => {
    const currentPath = window.location.pathname;
    if (e === "asian") {
      // update api with asian selected session view
      window.history.replaceState({}, "", currentPath);

      props.updateSessionView(ScreenType.ASIAN);
    } else if (e === "european") {
      // update api with european selected session view
      window.history.replaceState({}, "", currentPath);

      props.updateSessionView(ScreenType.EUROPEAN);
    }
  };

  // translations for select alternative view dropdown
  static getDropdownTranslations: (name: string, props: any) => any = (
    name: string,
    props: Record<string, any>
  ) => {
    const lineTranslations = {
      asian: props.intl.formatMessage({
        id: "navigation-asia",
      }),
      europe: props.intl.formatMessage({
        id: "navigation-europe",
      }),
      select: props.intl.formatMessage({
        id: "navigation-select",
      }),
    };
    return lineTranslations[name];
  };
}
